import {
  Card,
  Divider,
  Illustration,
  List,
  ListItemButton,
  ListItemText,
  Text,
  type UseModalState,
} from "@clipboard-health/ui-components";
import { CardContent, Stack } from "@mui/material";
import { APP_V2_USER_EVENTS } from "@src/appV2/lib/analytics";
import { logEvent } from "@src/appV2/lib/analytics/log";
import { type FavoriteWorkplaceFormatted } from "@src/appV2/Workplaces/api/useFavoriteWorkplaces";
import { Fragment } from "react";
import { useHistory } from "react-router-dom";

import { Button } from "../../components/Button";
import { SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH } from "../paths";
import { useWorkplaceModalsDataContext } from "../useWorkplaceModalsDataContext";

interface NoShiftsEmptyStateProps {
  favoriteWorkplaces: FavoriteWorkplaceFormatted[];
  pickerModalState: UseModalState;
}

export function NoShiftsEmptyState(props: NoShiftsEmptyStateProps) {
  const { favoriteWorkplaces, pickerModalState } = props;
  const history = useHistory();

  const { generateModalPath } = useWorkplaceModalsDataContext();

  return (
    <Stack sx={{ px: 6, mt: 4 }} justifyContent="center" alignItems="center" gap={6}>
      <Stack alignItems="center" gap={2}>
        <Illustration type="facility" />

        <Text semibold variant="h5" textAlign="center">
          No open shifts at your favorite workplaces. Check back later.
        </Text>
      </Stack>

      <Card
        sx={{
          border: "2px solid",
          borderColor: "divider",
          width: "100%",
          maxWidth: 420,
        }}
      >
        <CardContent>
          <Text semibold variant="h6" sx={{ mt: 2, mb: 4 }}>
            Your favorite workplaces
          </Text>
          <Divider sx={{ my: 4 }} />
          <List dense>
            {favoriteWorkplaces.map((favoriteWorkplace, index) => {
              return (
                <Fragment key={favoriteWorkplace.workplaceId}>
                  <ListItemButton
                    onClick={() => {
                      const workplaceProfileModalPath = generateModalPath(
                        SHIFT_DISCOVERY_WORKPLACE_PROFILE_MODAL_PATH,
                        {
                          workplaceId: favoriteWorkplace.workplaceId,
                        }
                      );
                      history.push(workplaceProfileModalPath);
                    }}
                  >
                    <ListItemText>
                      <Text variant="body2">{favoriteWorkplace.workplace?.name}</Text>
                    </ListItemText>
                  </ListItemButton>

                  {index !== favoriteWorkplaces.length - 1 && <Divider sx={{ my: 4 }} />}
                </Fragment>
              );
            })}
          </List>
        </CardContent>
      </Card>

      <Button
        variant="outlined"
        size="large"
        startIconType="like-outlined"
        onClick={() => {
          logEvent(APP_V2_USER_EVENTS.UPDATE_FAVORITE_WORKPLACES_BUTTON_CLICKED, {
            state: "no_shifts",
          });
          pickerModalState.openModal();
        }}
      >
        Update Favorite Workplaces
      </Button>
    </Stack>
  );
}
